import React from 'react';
import { Link } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { createPageUrl } from '@/utils';
import { getCalmedicaHgoHierarchy } from '@/lib/calmedicaAccountHierarchy';

function accountPageHref(accountId) {
  return createPageUrl(`AccountFinal?id=${encodeURIComponent(String(accountId || '').trim())}`);
}

/**
 * Calmedica / HGO only — returns null for all other tenants and accounts.
 */
export default function CalmedicaOrganisationLinks({ accountId, accountName, tenantId }) {
  const ctx = getCalmedicaHgoHierarchy({ accountId, accountName, tenantId });
  if (!ctx) return null;

  if (ctx.role === 'parent') {
    return (
      <div className="max-w-7xl mx-auto px-4 md:px-6 pb-2">
        <Card className="border border-[#00C2C2]/20 shadow-sm bg-white">
          <CardHeader className="py-3 px-4 md:px-5">
            <CardTitle className="text-sm md:text-base font-semibold text-[#0A1A2F] flex items-center gap-2">
              <Building2 className="w-4 h-4 text-[#00C2C2] shrink-0" aria-hidden />
              Subsidiary sites
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-0 px-4 md:px-5 pb-4">
            <ul className="flex flex-col gap-1.5 text-sm text-[#5C6B7A]">
              {ctx.subsidiaries.map((row) => (
                <li key={row.account_id}>
                  <Link
                    to={accountPageHref(row.account_id)}
                    className="text-[#00A3A3] hover:text-[#008080] hover:underline font-medium"
                  >
                    {row.label}
                  </Link>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 pb-2">
      <Card className="border border-[#00C2C2]/20 shadow-sm bg-white">
        <CardHeader className="py-3 px-4 md:px-5">
          <CardTitle className="text-sm md:text-base font-semibold text-[#0A1A2F] flex items-center gap-2">
            <Building2 className="w-4 h-4 text-[#00C2C2] shrink-0" aria-hidden />
            Parent organisation
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-0 px-4 md:px-5 pb-4">
          <p className="text-sm text-[#5C6B7A]">
            Part of{' '}
            <Link
              to={accountPageHref(ctx.parentAccountId)}
              className="text-[#00A3A3] hover:text-[#008080] hover:underline font-semibold"
            >
              {ctx.parentLabel}
            </Link>
            .
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
